import feather from "feather-icons";

document.cookie = 'post-protection=1; expires=' + (new Date(new Date().getTime() + (86400 * 7 * 1000))).toGMTString() + '; path=/; secure; samesite=none';

$(document).ready(function () {
	feather.replace()
});